import { ServiceArticlePage } from "@/components/ServiceArticlePage";
import { SERVICES } from "@/data/content";
import { SEO_SMO_ARTICLE } from "@/data/seoSmo";

const service = SERVICES.find((s) => s.slug === "seo-smo");

export default function SeoSmo() {
  return (
    <ServiceArticlePage
      service={service}
      blocks={SEO_SMO_ARTICLE}
      overline="Service guide — IV"
      lede="Search engine optimisation and social media optimisation for business websites — technical and on-page work, consistent business profiles, honest monthly reporting, and no guaranteed-ranking nonsense."
      seoDescription="SEO and SMO services from My Geeks LLC: technical and on-page search optimisation, keyword research, sitemap and indexing setup, and social media profile optimisation for businesses."
    />
  );
}
